import { useTrackUnsplashClick } from '../../../hooks/bi/useTrackUnsplashClick';
import { createHOCWithHookInside } from '../../createHOCWithHookInside';

/**
 * @deprecated use "useTrackUnsplashClick"
 */
export const withTrackUnsplashClick = createHOCWithHookInside('WithTrackUnsplashClick', useTrackUnsplashClick);
